import { getAuth } from "firebase/auth";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
  useRouteError,
} from "react-router-dom";
import Result from "antd/es/result";
import { Button } from "antd";
import { INTENTS } from "~/utils/constants";
import { apiClient } from "~/services/apiClient";
import { BackgroundCheckFormValues } from "~/types";
import { getShadowInviteResumeUrl } from "~/utils/shadowInviteStorage";

export const BackgroundCheckPageLoader = async ({
  request,
}: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return redirect("/signup");
  const resumeInvite = getShadowInviteResumeUrl();
  if (resumeInvite) {
    return redirect(resumeInvite);
  }
  return {};
};

export type BackgroundCheckPageLoaderType = {};

export const BackgroundCheckPageAction = async ({
  request,
}: ActionFunctionArgs) => {
  const formData = await request.formData();
  const intent = formData.get("intent");

  switch (intent) {
    case INTENTS._submit_background_check_info: {
      const auth = getAuth();
      const user = auth.currentUser;
      const userID = user?.uid ?? "";

      if (!userID) {
        throw new Response(JSON.stringify({ error: "Not authenticated" }), {
          headers: { "Content-Type": "application/json" },
          status: 401,
        });
      }

      const payload = JSON.parse(
        formData.get("body") as string,
      ) as BackgroundCheckFormValues;

      const result = await apiClient.sendIntent(
        INTENTS._submit_background_check_info,
        { id: userID, ...payload },
      );

      if (!result.success) {
        throw new Response(
          JSON.stringify({
            error: result.error ?? "Failed to submit background check info",
          }),
          {
            headers: { "Content-Type": "application/json" },
            status: 500,
          },
        );
      }

      return redirect("/");
    }
  }
  return {};
};

export const BackgroundCheckPageErrorBoundary = () => {
  const error = useRouteError();
  console.error("Background check page error", error);
  let subTitle = "Sorry, something went wrong."; // TODO [Translate]

  return (
    <Result status="500" title="500" subTitle={subTitle}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button type="primary" href="/">
          Back Home
        </Button>
      </div>
    </Result>
  );
};
